module.exports = __webpack_public_path__ + "static/img/111.dbb2e6d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/2/111.png
// module id = Uewg
// module chunks = 0